import React, { PureComponent, ChangeEvent } from 'react';
import { TextField } from '@cimpress/react-components';

interface TraceRulerSettingsProps {
    color: string;
    spacing: number;
    setTraceRulerColor: (color: string) => void;
    setTraceRulerSpacing: (spacing: number) => void;
}

interface TraceRulerSettingsState {
    currentSpacing: number;
    status?: 'error';
}

const isError = (value: number) => (!(Number.isFinite(value) && value >= 10 && value <= 500) ? 'error' : undefined);

export default class TraceRulerSettings extends PureComponent<TraceRulerSettingsProps, TraceRulerSettingsState> {
    state: TraceRulerSettingsState = {
        currentSpacing: this.props.spacing,
        status: isError(this.props.spacing),
    };

    onColorChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { setTraceRulerColor } = this.props;
        setTraceRulerColor(e.target.value);
    };

    onSpacingChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = parseFloat(e.target.value);
        const error = isError(value);
        this.setState({ currentSpacing: value, status: error });
        if (!error) {
            const { setTraceRulerSpacing } = this.props;
            setTraceRulerSpacing(value);
        }
    };

    static getDerivedStateFromProps(
        nextProps: TraceRulerSettingsProps,
        prevState: TraceRulerSettingsState,
    ): Partial<TraceRulerSettingsState> | null {
        if (nextProps.spacing !== prevState.currentSpacing) {
            return {
                currentSpacing: nextProps.spacing,
                status: isError(nextProps.spacing),
            };
        }
        return null;
    }

    render() {
        const { color } = this.props;
        const { currentSpacing, status } = this.state;

        return (
            <div className='trace-ruler-settings-panel'>
                <div className='trace-ruler-settings-panel__header'>Crosshair Settings</div>
                <div className='trace-ruler-settings-panel__field'>
                    <label htmlFor='trace-ruler-color-input'>Line Color:</label>
                    <div className='trace-ruler-settings-panel__color-row'>
                        <input
                            id='trace-ruler-color-input'
                            type='color'
                            value={color}
                            onChange={this.onColorChange}
                            className='trace-ruler-settings-panel__color-picker'
                        />
                        <span className='trace-ruler-settings-panel__color-value'>{color.toUpperCase()}</span>
                    </div>
                </div>
                <div className='trace-ruler-settings-panel__field'>
                    <TextField
                        className='trace-ruler-settings-panel__spacing-field'
                        label='Grid Spacing (px)'
                        value={currentSpacing || (currentSpacing === 0 ? 0 : '')}
                        status={status}
                        onChange={this.onSpacingChange}
                        type='number'
                        onFocus={(e: React.FocusEvent<HTMLInputElement>) => e.target.select()}
                    />
                </div>
            </div>
        );
    }
}
